// Partial product-code (SKU) search helpers.
// Asana: [30/6] Product code not working on search bar (task 1216136383452946).
// Customers search by the product code (the numeric prefix of the SKU, e.g. 010162910010)
// rather than the full variant SKU. Turning a bare numeric code into a prefix match lets
// Shopify's Search API match the start of the SKU.
function toSkuQuery(term) {
	const trimmed = (term || "").trim();
	if (!trimmed) return trimmed;
	// Don't double the wildcard on re-submit / back button / shared URL.
	if (trimmed.endsWith("*")) return trimmed;
	// Only a single, all-numeric token looks like a product code. Kept as a string so
	// leading zeros are preserved (010… must not become 10…). Names and multi-word
	// queries pass through untouched so normal search and analytics are unaffected.
	if (/^\d+$/.test(trimmed)) return `${trimmed}*`;
	return trimmed;
}

// Strip a trailing wildcard so the appended `*` never shows in an input or heading.
function stripSkuWildcard(term) {
	return (term || "").replace(/\*+$/, "");
}

class SearchForm extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');

		if (this.input) {
			this.input.form.addEventListener("reset", this.onFormReset.bind(this));
			this.input.addEventListener(
				"input",
				debounce((event) => {
					this.onChange(event);
				}, 300).bind(this),
			);

			if(this.input.parentElement.querySelector(".search__input--icon-clear") != null) {
				let clearIcon = this.input.parentElement.querySelector(".search__input--icon-clear");
				
				clearIcon.addEventListener('click', () => {
					this.input.form.reset();
					this.onFormReset();
				});
			}
		}
	}

	shouldResetForm() {
		return !document.querySelector('[aria-selected="true"] a');
	}

	onFormReset(event) {
		// Prevent default so the form reset doesn't set the value gotten from the url on page load
		if (event) {
			event.preventDefault();
		}
		// Don't reset if the user has selected an element on the predictive search dropdown
		if (this.shouldResetForm()) {
			this.input.value = "";
			//this.input.focus();
		}
	}
}

customElements.define("search-form", SearchForm);
